// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-l_gL"};